import {GTM_EVENT, GTM_VARIABLE, gtmLogEcommerceEvent, gtmLogEvent, gtmSetValue} from "./analytics-gtm";
import {isValid, mygaSession} from "./myga-session";
import {PAGES, STATE, STORAGE_KEYS} from "./constants";
import {MM_CALCULATOR, MM_PRODUCT} from "./myga-model";

export class Analytics {
  
  static setValue = (key, value) => {
    gtmSetValue(key,value);
    // add other value setters here
  };
  
  static logEvent = (name, params = {}) => {
    gtmLogEvent(name,params);
    // add other event handlers here
  }
  
  // -----------------------
  // event helpers
  // -----------------------
  
  static restart = () => {
    // handle GTM  restart
    let page = mygaSession.getMygaSessionValue(STATE.page,PAGES.pageLanding);
    gtmSetValue(GTM_VARIABLE.mygaPage,page);
    gtmSetValue(GTM_VARIABLE.mygaPageMax,mygaSession.getMygaSessionValue(STORAGE_KEYS.maxPage,page));
    gtmSetValue(GTM_VARIABLE.mygaAgentReferralCode, mygaSession.getAgentReferralCode("(null)"));
    gtmSetValue(GTM_VARIABLE.mygaPrincipalToken,mygaSession.getPrincipalToken("(null)"));
  }
  
  static setPage = (value) => {
    gtmSetValue(GTM_VARIABLE.mygaPage,value);
    // add other analytics services here
  }
  
  static setPageMax = (value) => {
    gtmSetValue(GTM_VARIABLE.mygaPageMax,value);
    // add other analytics services here
  }
  
  static setPrincipalToken = (value) => {
    gtmSetValue(GTM_VARIABLE.mygaPrincipalToken,value);
    // add other analytics services here
  }
  
  static setAgentReferralCode = (value) => {
    gtmSetValue(GTM_VARIABLE.mygaAgentReferralCode,value);
    // add other analytics services here
  }
  
  static setUsername = (value) => {
    gtmSetValue(GTM_VARIABLE.mygaUsername,value);
    // add other analytics services here
  }
  
  static setSessionId = (value) => {
    gtmSetValue(GTM_VARIABLE.mygaSessionId,value);
    // add other analytics services here
  }
  
  static setIdScanStatus = (value) => {
    gtmSetValue(GTM_VARIABLE.mygaIdScanStatus,value);
    // add other analytics services here
  }
  
  static setSubmissionPathA = () => {
    gtmSetValue(GTM_VARIABLE.mygaSubmissionPath,"A");
    // add other analytics services here
  }
  
  static setSubmissionPathB = () => {
    gtmSetValue(GTM_VARIABLE.mygaSubmissionPath,"B");
    // add other analytics services here
  }
  
  static setSubmissionPathC = () => {
    gtmSetValue(GTM_VARIABLE.mygaSubmissionPath,"C");
    // add other analytics services here
  }
  
  
  static firePageNavigated = (params={}) => {
    gtmLogEvent(GTM_EVENT.pageNavigated,params);
    // add other analytics services here
  }
  
  static fireAppStarted = (params={}) => {
    gtmLogEvent(GTM_EVENT.appStarted,params);
    // add other analytics services here
  }
  
  static fireIdScanStarted = (params={}) => {
    gtmLogEvent(GTM_EVENT.idScanStarted,params);
    // add other analytics services here
  }
  
  static fireIdScanFinished = (params={}) => {
    gtmLogEvent(GTM_EVENT.idScanFinished,params);
    // add other analytics services here
  }
  
  /**
   * Fires a product selected event
   * @param products an array of product description objects
   * @param productListName optional product list name
   * @param productListID optional product list ID
   */
  static fireProductSelected = (products=[], productListName='default', productListID='default') => {
    gtmLogEcommerceEvent(GTM_EVENT.productSelected, {
      'currency': 'USD',
      'items': products.map(p=>productToGA4Item(p)),
      'item_list_name': productListName,
      'item_list_id' : productListID
    });
    // add other analytics services here
  }
  
  /**
   * Fires a product add-to-cart event
   * @param products an array of product description objects
   */
  static fireProductAddToCart = (products=[]) => {
    gtmLogEcommerceEvent(GTM_EVENT.productAddToCart,{
      'currency': 'USD',
      'items': products.map(p=>productToGA4Item(p))
    });
    // add other analytics services here
  }
  
  /**
   * Fires a product remove-from-cart event
   * @param products an array of product description objects
   */
  static fireProductRemoveFromCart = (products=[]) => {
    gtmLogEcommerceEvent(GTM_EVENT.productRemoveFromCart,{
      'currency': 'USD',
      'items': products.map(p=>productToGA4Item(p))
    });
    // add other analytics services here
  }
  
}


// GTM Product Adapter
const productToGA4Item = (product) => {
  let item = {};
  item['item_id'] = product[MM_PRODUCT.productID];
  
  if (isValid(product[MM_PRODUCT.productName])) {
    item['item_name'] = product[MM_PRODUCT.productName];
  }
  
  if (isValid(product[MM_PRODUCT.productBrand])) {
    item['item_brand'] = product[MM_PRODUCT.productBrand];
  }
  
  if (isValid(product[MM_PRODUCT.productType])) {
    item['item_category'] = product[MM_PRODUCT.productType];
  }
  
  // check for a calculator
  let calc = product[MM_PRODUCT.calculator];
  if (isValid(calc)) {

    // surrender period goes to category 2
    if (isValid(calc[MM_CALCULATOR.surrenderPeriod])) {
      item['item_category2'] = `Surrender Period: ${calc[MM_CALCULATOR.surrenderPeriod]}`;
    }
    
    // rate goes into category 3
    if (isValid(calc[MM_CALCULATOR.rate])) {
      item['item_category3'] = `Rate: ${calc[MM_CALCULATOR.rate].toFixed(2)}%`;
    }
  
    // extract the product "price"
    if (isValid(calc[MM_CALCULATOR.premium])) {
      item['price'] = Number.parseFloat(`${calc[MM_CALCULATOR.premium]}`);
    
      // Set the currency to USD
      item['currency'] = 'USD';
      
      // always only 1 (currently?)
      item['quantity'] = 1;
    }
  
  }
  
  return item;
}